import { IS_DEV } from '../constants';

const devLog = IS_DEV ? console.log : () => {};

export default devLog;
